import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import AddCardModalFrames from './AddCardModalFrames';
import AddCardModalFlow from './AddCardModalFlow';

interface AddCardModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Add-card modal switch. Renders the checkout.com Flow implementation when the `flowPaymentsEnabled`
 * LaunchDarkly flag is on, otherwise the legacy Frames implementation. Flag defaults off, so
 * behaviour is unchanged until it is flipped. LD flag key: `flow-payments-enabled`.
 */
export default function AddCardModal({ open, onClose }: AddCardModalProps) {
  const { flowPaymentsEnabled } = useFlags();
  return flowPaymentsEnabled ? (
    <AddCardModalFlow open={open} onClose={onClose} />
  ) : (
    <AddCardModalFrames open={open} onClose={onClose} />
  );
}
